import React, { useRef } from "react"
import { useReactToPrint } from "react-to-print"
import XOutReportReceipt, { XOutReportData } from "./index"
import { Box, Button } from "@mui/material"
import { PaymentMethod } from "src/graphql/quark/quark.type"

// Sample data for demonstration
const demoReportData: XOutReportData = {
  startDate: "2025-01-22T00:00:00.000Z",
  endDate: "2025-01-22T00:00:00.000Z",
  registerName: "Pharmacy",
  [PaymentMethod.Cash]: {
    gross: 2500.0,
    discount: 250.0,
    tax: 0.0,
    sale: 0.0,
    returns: 0.0,
    net: 2250.0,
    transactions: 15
  },
  [PaymentMethod.Card]: {
    gross: 4750.0,
    discount: 0.0,
    tax: 0.0,
    sale: 0.0,
    returns: 125.0,
    net: 4625.0,
    transactions: 23
  },
  [PaymentMethod.Credit]: {
    gross: 1800.0,
    discount: 180.0,
    tax: 0.0,
    sale: 0.0,
    returns: 0.0,
    net: 1620.0,
    transactions: 7
  },
  [PaymentMethod.BankTransfer]: {
    gross: 3200.0,
    discount: 0.0,
    tax: 0.0,
    sale: 0.0,
    returns: 150.0,
    net: 3050.0,
    transactions: 12
  },
  total: {
    gross: 12250.0,
    discount: 430.0,
    tax: 0.0,
    sale: 0.0,
    returns: 275.0,
    net: 11545.0,
    transactions: 57
  },
  printDate: new Date().toISOString()
}

const DemoXOutReport: React.FC = () => {
  const componentRef = useRef(null)

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "X-Out Report",
    onAfterPrint: () => console.log("Print completed")
  })

  return (
    <Box sx={{ p: 3 }}>
      <Button variant="contained" color="primary" onClick={() => handlePrint()} sx={{ mb: 2 }}>
        Print Report
      </Button>

      <XOutReportReceipt reportData={demoReportData} receiptRef={componentRef} />
    </Box>
  )
}

export default DemoXOutReport
